import { DocumentsSection } from "Components/AML/AMLUserDetail/shared/DocumentsSection";
import { NaturalPersonBasicInfoSection } from "Components/AML/AMLUserDetail/shared/NaturalPersonBasicInfoSection";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { usePartyActingPersonParty } from "Hooks/useUserActingPersonParty";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  owningPartyID: string;
};

export const ActingPersonSection = ({ owningPartyID }: Props) => {
  const { actingPartyData, isLoading } =
    usePartyActingPersonParty(owningPartyID);
  const { t } = useResource();

  if (isLoading) {
    return <>{t(Resources.AML.Loading)}</>;
  }

  if (!actingPartyData) {
    return <ErrorText>{t(Resources.Error.ActingPersonFailed)}</ErrorText>;
  }

  return (
    <>
      <NaturalPersonBasicInfoSection
        partyData={actingPartyData}
        title={t(Resources.AML.ActingPerson)}
      />
      <DocumentsSection partyData={actingPartyData} />
    </>
  );
};
